$("#truck-modal").click(function () {$("#truck-comtainer-modal").css({"display": "block"})});
$("#truck-modal-mobile").click(function () {$("#truck-comtainer-modal").css({"display": "block"})});
$(".truck-icon-item").click(function () {$("#truck-comtainer-modal").css({"display": "none"})});


$("#selector-live-search").click(function () {
    if ($("body").width() <= 1024 ){
        $('#desplegable-live-search').slideToggle();
        $('#item-live-search').toggleClass('desplegable-off');
    }
});

function onRisize() {
    if ($("body").width() <= 1024 ){
        $('#item-live-search').appendTo('#desplegable-live-search');
        $('#selector-live-search').css({
            "display": "block"
        });
        $("#live-search-container").css({
            "display": "flex",
            "justify-content": "flex-end"
        });



      
        $("#mobile-menu-container").css({
            "display": "flex"
        })
    }else{



      

        $('#selector-live-search').css({
            "display": "none"
        });
        $("#mobile-menu-container").css({
            "display": "none"
        })
        $("#live-search-container").css({
            "display": "",
            "justify-content": ""
        });



      
        $("#desplegable-live-search").css({
            "display": "none"
        });
    }
}

$(window).resize(function(){
  onRisize()
  generarSliders()
});
$(function(){
    onRisize();
    generarSliders()

})


 
function generarSliders(){
    widthWindow = document.documentElement.clientWidth;
    const $el = $("#slidershow-container");
    const height = $el.height();
    const width = $(window).width();
    if(width <= 700) $el.height(width);
    else $el.height("auto");
    if (widthWindow <= 520) { 

        /** */
        try {
            $('.lista-imagenes').slick({
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                settings: {
                    arrows: true,
                }
            });
       
            $('.slider-mobile').slick({
                infinite: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                settings: {
                    arrows: true,
                }
            }); 
            $('.promo-slider').slick({
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                settings: {
                    arrows: true,
                }
            }); 
            $.each($(".lista-iconos"), function (index, key) {

                let itemsRow = $(this).attr("data-items")


                $(this).slick({
                    infinite: true,
                    slidesToShow: itemsRow,
                    slidesToScroll: 1,
                    settings: {
                        arrows: true,
                    }
                });
            })
        } catch (error) {
            setTimeout(() => {
                
            }, 100);
        }
        $.each($(".cambioImagenMobile"), function (index, key) {
 
            let imgMobile = $(this).attr("data-bgmobile"); 
            $(this).css("background-image",'url("'+ imgMobile+' ")')
        })
        /**/
    } else {
        try {

            $('.lista-imagenes,.slider-mobile,.promo-slider,.lista-iconos').slick('unslick');
        } catch (error) {

        }
    }
}

setTimeout(function () {
    const $el = $("#slidershow-container");
    const height = $el.height();
    const width = $(window).width();
    if(width <= 700) $el.height(width);
    else $el.height("auto");
    
    $("button[class='flickity-button flickity-prev-next-button next']").append("<img alt='Next' src='//bebesit.cl/cdn/shop/t/166/assets/Copy%20of%20WFLECHAI.png?v=130242628817836378511754587487' >");
    $("button[class='flickity-button flickity-prev-next-button previous']").append("<img alt='Previous' src='//bebesit.cl/cdn/shop/t/166/assets/Copy%20of%20WFLECHAD.png?v=79995401687084863011754587487' >");
},500)


$(".site-header-button.site-header-menu-button").on("click",function(){
    $(".site-mobile-nav").addClass("visible");

})

$(".close-icon-burger").on("click",function(){
  $(".site-mobile-nav").removeClass("visible");
  $(".template-index").removeClass("scroll-lock");
})
